import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//                          Отправить новое мнение на сервер
//------------------------------------------------------------------------------
export const sendNewOpinion = async (data) => {
  const url = `${ backendUrl }/api/alpha/all/`;
  const options = {
    method: 'POST',
    body: data,
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при отправке мнения на сервер: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка отправки мнения на сервер:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx